import { useCallback, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useUpdateRfid() {
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState("");

  const { send, isConnected, connect } = useWebSocketContext();
  const mountedRef = useRef(true);

  const updateRfid = useCallback(
    async ({ rfid, status, expiry_date }) => {
      if (!mountedRef.current) return;

      setIsUpdating(true);
      setError("");

      try {
        if (!isConnected) {
          await connect();
        }

        const payload = { rfid };
        if (status) payload.status = status;
        if (expiry_date !== undefined) payload.expiry_date = expiry_date;

        const response = await send("cms_update_rfid", payload);

        if (!response || response.type !== "update_rfid_response") {
          throw new Error("Invalid response from server");
        }

        if (!response.status) {
          throw new Error(response.message || "Failed to update RFID");
        }

        return response.data;
      } catch (err) {
        setError(err.message || "Failed to update RFID");
        throw err;
      } finally {
        if (mountedRef.current) setIsUpdating(false);
      }
    },
    [isConnected, connect, send]
  );

  return {
    updateRfid,
    isUpdating,
    error,
  };
}
